import React from 'react';
import styled from 'styled-components';
import { typography, colors } from '../../../lib/styles';
import { FormattedMessage } from '@99designs/frontend-components/i18n';

interface PaginationSummaryProps {
    currentPage: number;
    totalPages: number;
}

const StyledPaginationSummary = styled.span`
    font-family: ${typography.fontFamilies.heading};
    font-size: 19px;
    min-width: 90px;
    text-align: center;
    color: ${colors.grey800};
`;

export default function PaginationSummary({ currentPage, totalPages }: PaginationSummaryProps) {
    return (
        <StyledPaginationSummary>
            <FormattedMessage
                message={__('{currentPage} of {totalPages}')}
                values={{
                    currentPage,
                    totalPages,
                }}
            />
        </StyledPaginationSummary>
    );
}
